export default __webpack_public_path__ + "static/media/tokensPromoLight.bef97fb5.png";